import { render, staticRenderFns } from "./type-ahead-editor.vue?vue&type=template&id=09f5d6ce&"
import script from "./type-ahead-editor.vue?vue&type=script&lang=ts&"
export * from "./type-ahead-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports